import { Decoration } from '@atlaskit/editor-prosemirror/view';

/**
 * Portal key used to render the TelepointerAvatar React component into the telepointer
 * avatar container DOM element. Shared by both streaming plugin implementations to ensure
 * consistent portal lifecycle management.
 */
export const TELEPOINTER_AVATAR_PORTAL_KEY = 'inEditorAITelepointerAvatar';

export type TelepointerElements = {
	avatarContainer: HTMLSpanElement;
	element: HTMLSpanElement;
	labelElement: HTMLSpanElement;
};

export const createTelepointerElement = (label: string): TelepointerElements => {
	const element = document.createElement('span');
	element.setAttribute('data-testid', 'ai-in-editor-telepointer-widget');
	element.className = 'ai-in-editor-telepointer';

	const labelElement = document.createElement('span');
	labelElement.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-label');
	labelElement.className = 'ai-in-editor-telepointer-label';
	labelElement.append(label);
	element.appendChild(labelElement);

	const avatarContainer = document.createElement('span');
	avatarContainer.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-avatar');
	avatarContainer.className = 'ai-in-editor-telepointer-avatar';
	// Hidden by default; shown when AgentAvatar is rendered into it.
	// To show: set style.display = '' (removes inline style, falls back to browser default: 'inline' for <span>)
	avatarContainer.style.display = 'none';
	element.appendChild(avatarContainer);

	return { element, labelElement, avatarContainer };
};

export const createTelepointerWidget = (position: number, element: HTMLElement): Decoration => {
	return Decoration.widget(position, element, {
		side: 0,
		key: 'inEditorAIContentDecoration',
	});
};
